"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _recompose = require("../recompose");
var _Auth = _interopRequireDefault(require("./Auth"));
var withAuth = function withAuth(WrappedComponent) {
  var Component = function Component(props) {
    return /*#__PURE__*/_react.default.createElement(_Auth.default, {
      render: function render(authComponentProps) {
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, Object.assign({}, props, {
          auth: authComponentProps
        }));
      }
    });
  };
  Component.displayName = (0, _recompose.wrapDisplayName)(WrappedComponent, 'withAuth');
  return Component;
};
var _default = exports.default = (0, _recompose.hoistStatics)(withAuth);